export default __webpack_public_path__ + "static/media/loginImg.f1a16a68.png";